/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Параметры аутентификации FB Instant Games.
 * Для обычного режима заполняется ApplicationScopedId (ASID).
 * Для Zero Permissions (NEZP) режима заполняется PlayerId.
 * Ровно одно из двух полей должно быть заполнено.
 * @export
 * @interface FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
 */
export interface FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions {
    /**
     * ASID — для существующих юзеров, принявших TOS.
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    ApplicationScopedId?: string | null;
    /**
     * Player ID — для NEZP-юзеров без TOS.
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    PlayerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    Signature: string;
    /**
     * Подпись ASID для парного запроса; Signature подписывает Player ID.
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    ApplicationScopedIdSignature?: string | null;
    /**
     * Запрещает создание аккаунта, сохраняя поиск и безопасную привязку к существующему аккаунту.
     * null сохраняет legacy-поведение.
     * @type {boolean}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    ExistingAccountOnly?: boolean | null;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions(value: object): value is FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions {
    if (!('Signature' in value) || value['Signature'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'ApplicationScopedId': json['ApplicationScopedId'] == null ? undefined : json['ApplicationScopedId'],
        'PlayerId': json['PlayerId'] == null ? undefined : json['PlayerId'],
        'Signature': json['Signature'],
        'ApplicationScopedIdSignature': json['ApplicationScopedIdSignature'] == null ? undefined : json['ApplicationScopedIdSignature'],
        'ExistingAccountOnly': json['ExistingAccountOnly'] == null ? undefined : json['ExistingAccountOnly'],
    };
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSON(json: any): FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ApplicationScopedId': value['ApplicationScopedId'],
        'PlayerId': value['PlayerId'],
        'Signature': value['Signature'],
        'ApplicationScopedIdSignature': value['ApplicationScopedIdSignature'],
        'ExistingAccountOnly': value['ExistingAccountOnly'],
    };
}

